import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Fires a GA4 `page_view` event on every SPA route change.
 *
 * GA4 Enhanced Measurement page_view auto-collection is explicitly disabled in
 * the GTM container because it doesn't handle SPA routing reliably. This
 * component provides the correct manual replacement.
 *
 * Must be rendered inside `<BrowserRouter>` to access `useLocation()`.
 * Returns null - no DOM output.
 */
export function RouteAnalyticsTracker() {
  // `key` is a unique string assigned by React Router to every navigation
  // entry - it changes on pathname, search, and hash changes alike.
  const { key } = useLocation();

  useEffect(() => {
    window.dataLayer.push({
      event: 'page_view',
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [key]);

  return null;
}
